<style lang="scss" scoped>
  @import '../../../sass/variables';
  @import '../../../sass/mixins';

  .btn-light {
    @include salesflow-subtitle($color: $salesflow-font-dark, $font-weight: 600);
    background-color: $salesflow-outline-gray-light;
    border-color: $salesflow-outline-gray-light;
    padding: 12px 32px;
    white-space: nowrap;
    border-radius: 14px;
    margin-right: -8vw;
  }

  .btn-light:hover {
    @include salesflow-subtitle($color: $salesflow-font-dark, $font-weight: 600);
    background-color: $salesflow-outline-gray-medium;
    border-color: $salesflow-outline-gray-medium;
  }

  .align-center-objects {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .info-subscribe {
    color: #3b334a;
    font-size: 10px;
    font-weight: 500;
    font-style: italic;
    letter-spacing: -0.15px;
    line-height: 20px;
    margin-bottom: 5px;
  }

  @media (max-width: 1500px) {
    .btn {
      font-size: 11px;
    }
  }

  .cancel-subscription-link {
    color: #857a98;
    font-size: 10px;
    letter-spacing: -0.15px;
    line-height: 20px;
  }
</style>

<template>
  <section>
    <div class="row">
      <div class="offset-1 col-10 pl-5">
        <div v-if="tenant.subscribed && tenant.subscription">
          <div class="d-flex justify-content-between w-100 bg-success" style="min-width: 753px;">
            <div style="margin-top: -23px;">
              <BillingEditPlans
                v-if="tenant.plan"
                :current-plan="tenant.plan"
              />
            </div>
            <div
              style="margin-top: -77px;"
              v-if="tenant.subscribed && tenant.subscription"
            >

                  <a
                    class="btn btn-light mb-15px"
                    :href="tenant.last_invoice.url"
                    target="_blank"
                  >{{ __('Visualizar fatura') }}</a>

          </div>
          </div>

          <div class="row">
            <div
              class="d-inline-flex info-subscribe"
              v-if="(tenant.last_invoice.payment_method=='iugu_credit_card_test') || (tenant.last_invoice.payment_method=='iugu_credit_card')"
            >
              {{ __('Sua assinatura será renovada automaticamente em') }}
              {{ tenant.subscription.expires_at | datetime('LD') }}
              {{ __('no valor de R$') }}
              {{ (tenant.subscription.price) / 100 | number }}
              {{ __('em seu cartão de crédito') }}.
              <BillingEditCreditCard
                v-if="tenant.name"
                :account_name="tenant.name"
                :card_last_four="tenant.card_last_four"
              />
            </div>
          </div>
        </div>
        <div v-else>
          <div class="row info-subscribe">
            <p v-if="tenant.last_invoice">
              {{ __('Assinatura Expirada') }}.

              {{ __('Expiração') }}: {{ tenant.subscription.expires_at | datetime('LD') }}
              {{ __('Valor') }}: {{ tenant.last_invoice.total | currency }}.
            </p>
          </div>
          <div class="row mt-2">
            <a
              class="btn btn-primary"
              href="/checkout"
            >{{ __('Nova Assinatura') }}</a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Swal from 'sweetalert2';

export default {
  props: {
    tenant: {
      type: Object,
      required: true,
    },
  },

  methods: {
    confirmCancel () {
      Swal.fire({
        icon: 'question',
        title: this.__('Você tem certeza que quer alterar seu plano?'),
        width: 350,
        buttonsStyling: false,
        allowEscapeKey: false,
        allowOutsideClick: false,
        confirmButtonText: this.__('Sim'),
        cancelButtonColor: 'transparent',
        cancelButtonText: this.__('Não, quero voltar'),
        showCancelButton: true,
        customClass: {
          container: 'container-swal2',
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn swal2-btn-cancel-transparent swal2-btn-full-line',
        },
      }).then((result) => {
        if (result.dismiss !== 'cancel') {
          this.cancelSubscription();
        }
      });
    },

    cancelSubscription () {
      this.$http.delete('billing/c')
        .then(() => {
          this.changingPlan = false;
          this.currentPlan = this.newPlan;

          Alert.success(this.__('Assinatura cancelada.'));

          location.reload();
        }).catch(() => {
          Alert.error(this.__('Não foi possível cancelar sua assinatura.'));
        });
    },
  },
};
</script>
